import {BrowserRouter as Router} from 'react-router-dom'
import PropTypes from 'prop-types'

import ApplicationLayout from './components/ApplicationLayout'
import NotFound from './components/NotFound'
import RouteWithSubRoutes from './components/RouteWithSubRoutes'

const App = ({routes = []}) => {
  const appRoutes = [
    {
      path: '/',
      element: <ApplicationLayout />,
      children: [
        ...routes,
        {
          path: '*',
          element: <NotFound />
        }
      ]
    }
  ]

  return (
    <Router>
      <RouteWithSubRoutes routerConfig={appRoutes} />
    </Router>
  )
}

App.propTypes = {
  routes: PropTypes.array.isRequired
}

export default App
